<template>
  <v-card class="mb-4 hvh-card--rounded hvh-analysis-segments">
    <CardTitle :title="title + (segment.enabled ? '' : ' *')" :class="{ 'pb-0': !isCollapsed }" v-model="isCollapsed" />
    <v-card-text class="pt-0" v-show="!isCollapsed">
      <InputCheckbox class="mt-1" v-model="segment.enabled" :text="segment.name" color="#11697d" @input="onSelectionChange(segment)" />
      <template v-for="(child, ind) in segment.children">
        <InputCheckbox class="mt-1 hvh-analysis-segments__checkbox--lvl2" v-model="child.enabled" :text="child.name" color="#11697d" :key="child.name + ind" @input="onSelectionChange(child)" />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import CardTitle from '../common/cardTitle/HvhCardTitle.vue';
import InputCheckbox from '../common/form/inputCheckbox/HvhInputCheckbox.vue';

export default {
  components: { CardTitle, InputCheckbox },
  props: ['title', 'segment'],
  data() {
    return {
      isCollapsed: false,
    };
  },
  methods: {
    onSelectionChange(segment) {
      if (segment === this.segment) {
        this.segment.children.forEach(f => (f.enabled = false));
      } else {
        const childrenEnabled =
          this.segment.children.filter(f => f.enabled).length > 0;
        this.segment.enabled = !childrenEnabled;
      }

      this.$emit('change', this.segment);
    },
  },
};
</script>

<style lang="scss">
.hvh-analysis-segments {
  .v-input {
    display: block;
  }

  .v-label {
    color: $color-text-default;
    font-size: rem(14px);
  }
}

.hvh-analysis-segments__checkbox--lvl2 {
  padding-left: rem(12px);
}
</style>
